<div id="containerJobCreate">
  <div class="row">
      <div class="col-md-1 text-md-start">
          <button
              class="btn btn-mogo btn-secondary"
              (click)="onBack()"
          >
              <i class="fa fa-arrow-left"></i> Back
          </button>

      </div>
      <div class="col-md-11 mogo-bold">
          <h1>
              Create Container Job
          </h1>
      </div>
  </div>

  <div  *ngIf="isInitialized && !resettingForm">

        <form class="container-upsert-form-wrapper"
            *ngIf="createContainerJobForm"
            [formGroup]="createContainerJobForm"
            name="createContainerJobForm"
            novalidate
            autocomplete="off"
        >

            <app-container-job-basics-form
                  [formGroup]="getFormPartial('containerBasics')"
                  [freightPayers]="freightPayers"
                  [loadUnloadTypes]="loadUnloadTypes"
                  [containerSizes]="containerSizes"
                  [containerTypes]="containerTypes"
                  [divisions]="divisions"
              >
              </app-container-job-basics-form>


              <div class="item rounded p-2" *ngIf="isOutboundJob()">
                <div class="row">
                  <div class="col-md-12 p-4 pt-2 pb-2">
                    <div class="mb-2 border-bottom row">
                        <div class="col-md-10">
                          <div class="mogo-header-2 text-start ">Pickup Information</div>
                          </div>
                        </div>
                    </div>
                </div>
                <app-container-depot-hub-data-form
                    [formGroup]="getFormPartial('depotHub')"
                    [jobType]="getSelectedJobType()"
                    [isFullLegOnly]="isFullLegOnly()"
                    [selectedDivision]="getSelectedDivision()"
                    [isCollectPoint]="true"
                >
                </app-container-depot-hub-data-form>
                <div class="row">
                  <div [ngClass]="{'col-md-12': !showPack(), 'col-md-6': showPack()}">
                    <app-container-job-address-form
                        *ngIf="showFromAddress() && isFormReady"
                        label="PAK Site"
                        placeholder="PAK Site Address"
                        [formGroup]="getFormPartial('fromAddress')"
                        [jobType]="getSelectedJobType()"
                    >
                    </app-container-job-address-form>
                </div>

                  <div class="col-md-6" *ngIf="showPack() && !isIntermodalJob()">
                    <app-container-job-pack-properties
                        [formGroup]="createContainerJobForm"
                    ></app-container-job-pack-properties>
                </div>
                </div>
                
              </div>

            <div class="item rounded" *ngIf="showPortData()">
              <app-container-port-data
                    [formGroup]="getFormPartial('portData')"
                    [jobType]="getSelectedJobType()"
                    [isArrivingLeg]="false"
                >
                </app-container-port-data>
            </div>

            <div class="item rounded p-2" *ngIf="isInboundJob()">
              <div class="row">
                <div class="col-md-12 p-4 pt-2 pb-2">
                  <div class="mb-2 border-bottom row">
                      <div class="col-md-10">
                        <div class="mogo-header-2 text-start ">Delivery Information</div>
                        </div>
                      </div>
                  </div>
              </div>
              <div class="row">
                <div [ngClass]="{'col-md-12': !showDevan(), 'col-md-6': showDevan()}">
                    <app-container-job-address-form
                        *ngIf="showToAddress() && isFormReady"
                        label="To"
                        placeholder="To Address"
                        [formGroup]="getFormPartial('toAddress')"
                        [jobType]="getSelectedJobType()"
                    >
                    </app-container-job-address-form>
                </div>

                <div class="col-md-6" *ngIf="showDevan() && !isIntermodalJob()">
                    <app-container-job-devan-properties
                        [formGroup]="createContainerJobForm"
                    ></app-container-job-devan-properties>
                </div>
                
              </div>
              <app-container-depot-hub-data-form
                  [formGroup]="getFormPartial('depotHub')"
                  [jobType]="getSelectedJobType()"
                  [isFullLegOnly]="isFullLegOnly()"
                  [selectedDivision]="getSelectedDivision()"
                  [isCollectPoint]="true"
              >
              </app-container-depot-hub-data-form>
            </div>

            <div class="item rounded">
              <div class="p-2">
                <div class="row">
                  <div class="col-md-12 p-4 pt-2">
                    <div class="mb-2 border-bottom row">
                        <div class="col-md-10">
                          <div class="mogo-header-2 text-start ">Documents</div>
                          </div>

                        </div>
                    </div>
                </div>
                <div class="row">

                  <div class="col-md-12">
                    <div class="row document-input">
                      <div class="col-md-6">
                        <label class="mogo-bold" *ngIf="getFormPartial('bacc')!.value.length === 0">BACC/Compliance Documents</label>
                        <label class="mogo-bold" *ngIf="getFormPartial('bacc')!.value.length > 0">BACC/Compliance Documents provided
                            ✓</label>

                          <app-mogo-dropzone formControlName="bacc" height="70%"></app-mogo-dropzone>
                        </div>
                        <div class="col-6">
                            <label class="mogo-bold">Attachments</label>
                            <app-mogo-dropzone formControlName="attachments" height="70%"></app-mogo-dropzone>
                        </div>
                      </div>
                    </div>

              </div>
            </div>
            </div>
        </form>
      <div
          class="item rounded pb-5 mb-4  mt-3"
          *ngIf="isInitialized && !resettingForm"
      >
        <div class="p-2">
          <div class="row">
            <div class="col-12">
              <div class="mb-2 mogo-header-2 text-start p-2 border-bottom">Containers</div>
            </div>
          </div>

            <div class="offset-6 col-6 text-end">
              <button
                    class="btn btn-mogo btn-primary mx-1"
                    (click)="updateDefaults(createContainerJobForm.getRawValue())"
                >
                    Save Defaults
                </button>
                <button
                    class="btn btn-mogo btn-danger mx-1"
                    (click)="updateDefaults()"
                >
                    Clear Defaults
                </button>
                <button
                    class="btn btn-mogo btn-primary mx-1"
                    (click)="onClickAddContainers()"
                >
                    Add Containers
                </button>
                <button
                    class="btn btn-mogo btn-success mx-1"
                    [disabled] = "isSaving"
                    (click)="onCreateContainerJob()"
                >
                    Save Container Job
                </button>

          </div>



        </div>

        <bryntum-grid
            #grid
            [store]="gridConfig.store"
            [columns]="gridColumn"
            [filterBarFeature]="true"
            [height]="gridConfig.height"
            [width]="gridConfig.width"
            [rowHeight]="gridConfig.rowHeight"
            [enableTextSelection]="gridConfig.enableTextSelection"
            [tbar]="gridConfig.tbar"
            [selectionMode]="gridConfig.selectionMode"
            [listeners]="gridConfig.listeners"
        >
        </bryntum-grid>


      </div>
  </div>
</div>
